import React from "react";
import { Layout } from "antd";
import LoginPage from "../components/login/LoginComponent";

export default function Login() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LoginPage />
    </Layout>
  );
}
